import { createDraftSafeSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@src/redux/store';
import getCompanyList from './companyThunk';

export type SearchByType = 'name';

export interface CompaniesState {
  id?: number;
  updatedAt?: string;
  createdAt?: string;
  name?: string;
  avatarUrl?: string;
  accountantEmail: string;
  accountantMobileNumber: string;
  note: string;
}

export interface CompaniesMetaDto {
  totalItems?: number;
  totalPages?: number;
  currentPage?: number;
  itemsPerPage?: number;
}

export interface CompanyListParams {
  page?: number;
  limit?: number;
  sortBy?: string[];
  searchBy?: string[];
  search?: string;
  filter?: string;
}

interface InitialState {
  loading: boolean;
  companies: CompaniesState[];
  meta: CompaniesMetaDto;
  params: CompanyListParams;
}

const initialState: InitialState = {
  loading: false,
  companies: [],
  meta: {
    totalItems: 1,
    totalPages: 1,
  },
  params: {
    page: 1,
    limit: 20,
    sortBy: [''],
    searchBy: ['name'],
    search: '',
  },
};

const companiesSlice = createSlice({
  name: 'companies',
  initialState,
  reducers: {
    onChangePageNum(state, { payload }) {
      state.params.page = payload + 1;
    },
    onChangeLimit(state, { payload }) {
      state.params.limit = payload;
    },
    onChangeSearchBy(state, { payload }) {
      state.params.searchBy = payload;
    },
    onChangeSearch(state, { payload }) {
      state.params.search = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCompanyList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCompanyList.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.companies = payload.data;
      state.meta = payload.meta;
    });
    builder.addCase(getCompanyList.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const {
  onChangePageNum,
  onChangeLimit,
  onChangeSearch,
  onChangeSearchBy,
} = companiesSlice.actions;

export default companiesSlice.reducer;

const selfSelector = (state: RootState) => state.company;

export const companiesSelector = createDraftSafeSelector(
  selfSelector,
  (companiesState) => companiesState
);
